import React, { useCallback, useMemo, useState } from 'react';
import {
  ConfirmationRoot,
  Header,
  IconBack,
  SectionCards,
  Button,
} from './styles';
import BreadCrumb from '../BreadCrumb';
import StepCounter from '../StepCouter';
import ConfirmationAddress from './ConfirmationAddress';
import ConfirmationPhones from './ConfirmationPhones';
import ConfirmationEmails from './ConfirmationEmails';
import { useHistory, useLocation } from 'react-router-dom';
import { HandlerNextAction } from '../../pages/AbstractNegotiation/AbstractNegotiationService';
import IncorrectContact from '../IncorrectContact';

type Pages = {
  name: string;
  route: string;
};

type Steps = {
  step: number;
  name: string;
  title: string;
};

type StateProps = {
  addresses: GQL.IAddressConfirmation[];
  phones: GQL.IPhoneConfirmation[];
  emails: GQL.IEmailConfirmation[];
  contract: GQL.IDebt;
  negotiationOption: GQL.IOption;
};

const Confirmation: React.FC = () => {
  const history = useHistory();
  const location = useLocation<StateProps>();
  const {
    addresses,
    emails,
    phones,
    contract,
    negotiationOption,
  } = location.state;

  const pages: Pages[] = useMemo(
    () => [
      { name: 'Meus Débitos', route: '/contratos' },
      { name: 'Meu Débito', route: '/negociacao' },
      { name: 'Resumo', route: '/resumo-negociacao' },
    ],
    []
  );

  const steps: Steps[] = useMemo(
    () => [
      { step: 0, name: '', title: '' },
      { step: 1, name: 'Address', title: 'Confirme seu endereço abaixo: ' },
      { step: 2, name: 'Phones', title: 'Confirme seu telefone: ' },
      { step: 3, name: 'Emails', title: 'Confirme seu email: ' },
    ],
    []
  );
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [addressCode, setAddressCode] = useState<string | number | null>(null);
  const [phoneCode, setPhoneCode] = useState<string | number | null>(null);
  const [emailCode, setEmailCode] = useState<string | number | null>(null);

  const handlerNavigation = (action: string) => {
    if (action === 'next') {
      if (currentStep + 1 >= steps.length) return finishDeal();
      setCurrentStep((state) => state + 1);
    } else {
      if (steps[currentStep - 1].step === 0) return history.goBack();
      setCurrentStep((state) => state - 1);
    }
  };

  const finishDeal = useCallback(() => {
    HandlerNextAction({
      negotiationOption: negotiationOption,
      contract: contract,
      databaseId: contract.databaseId,
      history,
      dealInfos: {
        contrato: contract.contracts,
        opcaoID: `${negotiationOption.optionId}`,
        valorEntrada: negotiationOption.firstPortionValue,
        valorDemais: negotiationOption.othersPortionsValue,
        codigoEmail: Number(emailCode),
        codigoEndereco: Number(addressCode),
        codigoTelefone: Number(phoneCode),
      },
    });
  }, [addressCode, phoneCode, emailCode, contract, negotiationOption, history]);

  return (
    <ConfirmationRoot>
      <div className='content'>
        <Header>
          <div className='sub-section-header'>
            <div className='title-section-header'>
              <IconBack onClick={() => history.goBack()} />
              <h2 className='title'>Confirmação</h2>
            </div>
            <BreadCrumb
              previouPages={pages}
              currentPage='Confirmação'
              showBreadCrumbOnMinWidth={'960px'}
            />
            <div className='step-counter-mobile'>
              <StepCounter stepsQty={steps.length - 1} current={currentStep} />
            </div>
          </div>

          <div className='sub-section-header'>
            <h3 className='step-title'>{steps[currentStep].title}</h3>
            <div className='step-counter'>
              <StepCounter stepsQty={steps.length - 1} current={currentStep} />
            </div>
          </div>
        </Header>

        <SectionCards hiddeStep={!(steps[currentStep].step === 1)}>
          <ConfirmationAddress
            addresses={addresses}
            selectedId={addressCode}
            setSelectedId={setAddressCode}
          />
        </SectionCards>

        <SectionCards hiddeStep={!(steps[currentStep].step === 2)}>
          <ConfirmationPhones
            phones={phones}
            selectedId={phoneCode}
            setSelectedId={setPhoneCode}
          />
        </SectionCards>

        <SectionCards hiddeStep={!(steps[currentStep].step === 3)}>
          <ConfirmationEmails
            emails={emails}
            selectedId={emailCode}
            setSelectedId={setEmailCode}
          />
        </SectionCards>

        <div className='footer'>
          <Button color='white' onClick={() => handlerNavigation('previous')}>
            Voltar
          </Button>
          <Button color='primary' onClick={() => handlerNavigation('next')}>
            Próximo
          </Button>
        </div>
        <IncorrectContact />
      </div>
    </ConfirmationRoot>
  );
};

export default Confirmation;
